import { Component, Inject, Input, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { Subscription } from "rxjs";
import {
	FormErrorTypeAssign,
	FormErrorTypes,
	FORM_ERRORS
} from "../form-errors";

@Component({
	selector: "app-validation-errors",
	templateUrl: "./validation-errors.component.html",
	styleUrls: ["./validation-errors.component.scss"],
	standalone: false
})
export class ValidationErrorsComponent implements OnInit, OnDestroy {
	@Input() abstractControl!: AbstractControl | null;

	errors: Array<string> = [];

	private subscription = new Subscription();

	constructor(@Inject(FORM_ERRORS) private formErrors: FormErrorTypes) {}

	ngOnInit(): void {
		if (this.abstractControl) {
			this.subscription = this.abstractControl.valueChanges.subscribe(
				() => {
					this.verifyTypeError();
				}
			);
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	private clearErrors(): void {
		this.errors = [];
	}

	private verifyTypeError(): void {
		if (this.abstractControl) {
			this.clearErrors();
			const controlErrors = this.abstractControl.errors;
			if (controlErrors) {
				const keys = Object.keys(controlErrors);
				keys.map((key) => {
					const getError =
						this.formErrors[key as keyof FormErrorTypes];
					const text = getError(
						controlErrors[key] as FormErrorTypeAssign
					);
					this.errors.push(text);
				});
			}
		}
	}
}
